import * as React from "react";

import { cn } from "../lib/utils";

type InputVariant = "default" | "underline";

interface InputProps extends React.ComponentProps<"input"> {
  /**
   * Visual variant. `default` keeps the DS-v2 boxed look (TES-907).
   * `underline` = Stitch "Industrial Management Portal" underline-on-focus style
   * (`border-b-2 focus:border-primary-container`, screens 02/03/06/10). Opt-in only —
   * the boxed default is unchanged.
   */
  variant?: InputVariant;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        data-variant={variant}
        className={cn(
          // Shared base (sizing/typography/disabled) for both variants.
          "flex h-10 w-full bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          variant === "default" &&
            // DS v3 (TES-2253): EINER Control-Radius `rounded-md` (identisch zu Button/Select-Trigger),
            // 1px-Border; Fokus = 2px Deep-Blue-Bottom-Border als INSET-Shadow (kein Layout-Shift) statt Ring
            "rounded-md border border-input focus-visible:border-primary-container focus-visible:shadow-[inset_0_-2px_0_0_hsl(var(--primary-container))]",
          variant === "underline" &&
            // Underline-on-focus: 1px resting bottom border → 2px primary-container on focus.
            "rounded-none border-x-0 border-t-0 border-b border-input bg-transparent px-0 focus-visible:border-b-2 focus-visible:border-primary-container",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
